<mat-form-field class="w-full" [appearance]="appearance">
  <mat-label>Email</mat-label>
  <input matInput [formControl]="control" type="email" />

  @if (loading) {
  <div class="suffix" matSuffix>
    <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
  </div>
  }
  @else if (loginInfo != null) {
  <div class="suffix" matSuffix>
    @if (loginInfo.has_cookies) {
    <mat-icon>cookie</mat-icon>
    }
    <mat-icon color="success">check_circle</mat-icon>
    <button mat-button type="button" (click)="openEditDialog()">Edit</button>
  </div>
  }
  @else {
  <div class="suffix" matSuffix>
    <mat-icon color="fail">close</mat-icon>
    <button mat-button type="button" (click)="openAddDialog()">Add</button>
  </div>
  }
</mat-form-field>